import * as React from 'react';
import { cloneDeep, compact, find, flow, get, isEmpty, last, map } from 'lodash';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { IMtaActions, IMtaFormNames, IMtaState, PageForm } from '../../../../../../../../services/mta/models';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { mtaActions } from '../../../../../../../../services/mta/actions';
import { actions as brandingActions } from '../../../../../../../../services/branding/reducer';
import { IBrandingActions, II18nMessages } from '../../../../../../../../services/branding/models';
import { Button, Form, Grid, OverlayTrigger, Popover } from 'react-bootstrap';
import { FaInfoCircle, FaSpinner } from 'react-icons/fa';
import * as Commonmark from 'react-commonmark';
import { renderProductDefinition } from '../../../../Helpers';
import { canToleratePremium } from '../../../../../../../../helpers/Mta';
import { MTAPremiumMismatch } from '../Components/MTAPremiumMismatch';
import YourRenewal, {
  renewalTypeSelectionEnum
} from '../../../../../../../Quote/scenes/Payment/components/YourRenewal';
import MTAVoucherCode from '../../../../../../../../components/MTAVoucherCode';
import { MTACardHeader } from '../Components/MTACardHeader';
import { MTAButtons } from '../../../MTAButtons';
import { RemoveRegion } from '../../../../../../../../helpers/RemoveRegion';
import { LoadingSpinner } from '../../../../../../../../components/LoadingSpinner';
import { push } from 'react-router-redux';
import { MTARegionSelector } from '../Components/MTARegionSelector';
import { MTATripDurationSelector } from '../Components/MTATripDurationSelector';
import { getAnnualTripDurationOptions, setMTATripDuration } from '../../../MakeAChangeSelection/MTAHelpers';
import { MTACardConsent } from '../Components/MTACardConsent';
import { format } from 'date-fns';

interface IMTAChangeTripTypeFormProps extends InjectedFormProps<any> {
  mta: IMtaState;
  i18n: II18nMessages;
  mtaPolicy: any;
  change: any;
  dispatch: any;
  formValues: any;
  selectedPolicy: any;
  permissions: boolean;
  actions: {
    branding: IBrandingActions;
    mta: IMtaActions
    push: (route: string) => void;
  };

  renderDefinition(name: string, useProvidedString?: boolean): any;
}

class MTAChangeTripTypeForm extends React.Component<IMTAChangeTripTypeFormProps, any> {

  constructor(props) {
    super(props);
    const { dispatch, change, formValues } = props;
    dispatch(change('page', PageForm.MTA_CHANGE_TRIP_TYPE));
    dispatch(change('isUpsell', true));
    window.scrollTo(0, 0);
    this.state = {
      loading: false,
      allowContinue: false,
      premiumMismatch: false,
      originalSelected: get(formValues, 'metadata.region'),
    }
  }

  componentDidMount() {
    const { actions, change, dispatch, mtaPolicy, mta } = this.props;
    this.setState({ loading: true });
    dispatch(change('permissions', true));
    actions.mta.resetVoucherCode();
    Promise.resolve(dispatch(change('data.attributes', mtaPolicy))).then(() => {
      actions.mta.calculateMtaPremiums().then(() => {
        this.checkPremiumMismatch();
        setMTATripDuration(
          actions.branding.getProduct(),
          this.allowedMaxTripDuration(),
          mta,
          change,
          dispatch,
        );
        this.setState({ loading: false });
      }).catch(() => {
        this.setState({ loading: false });
      });
    })
  }

  componentDidUpdate(prevProps: Readonly<IMTAChangeTripTypeFormProps>, prevState: Readonly<any>, snapshot?: any) {
    const { permissions, dispatch, change } = this.props;
    if (permissions !== prevProps.permissions) {
      if (!permissions) {
        dispatch(change('data.attributes.metadata.renewal_status', renewalTypeSelectionEnum.MANUAL))
      }
    }
  }

  private checkPremiumMismatch = () => {
    const { actions } = this.props;
    const selectedScheme = actions.mta.getSelectedScheme();
    const grossPremium = get(selectedScheme, 'premium.gross');
    if (selectedScheme && canToleratePremium(grossPremium) === false) {
      this.setState({ premiumMismatch: true });
    } else if (!selectedScheme) {
      this.setState({ premiumMismatch: true });
    }
  }

  private getAmtScheme = () => {
    const { actions, mta } = this.props;
    const selectedScheme = actions.mta.getSelectedScheme();
    const stCoverLevel = get(selectedScheme, 'scheme.cover_level')
    const calculatedQuotes = mta.quotes;
    return find(calculatedQuotes, {
      'scheme': {
        'cover_level': stCoverLevel,
        'scheme_type': 'Annual Multi Trip'
      }
    });
  }

  public handleSubmit = () => {
    const { actions, dispatch, change, formValues } = this.props;

    const amtScheme = this.getAmtScheme();

    const amtSchemeId = get(amtScheme, 'scheme.id');

    if (amtSchemeId) {
      const policyIssuedAt = get(formValues, 'issuedAt');
      Promise.all([
        dispatch(change('data.attributes.commencesAt', policyIssuedAt)),
        dispatch(change('data.attributes.metadata.scheme_type', 'annual')),
        dispatch(change('data.attributes.metadata.destinations', null)),
        dispatch(change('data.attributes.metadata.state_cities', null)),
        dispatch(change('data.attributes.metadata.start_date', policyIssuedAt)),
        dispatch(change('data.attributes.metadata.end_date', '')),
        dispatch(change('data.attributes.metadata.scheme_id', amtSchemeId)),
        dispatch(change('data.attributes.scheme_id', amtSchemeId)),
        dispatch(change('data.attributes.metadata.upsell_date', format(new Date(), 'yyyy-MM-dd HH:mm:ss')))])
        .then(() => {
          this.setState({ loading: false })
          Promise.all([
            actions.mta.calculateMtaPremiums(),
          ]).then(() => {
            const amtScheme = this.getAmtScheme();
            const endDate = get(amtScheme, 'information.end_date', '')
            Promise.resolve(dispatch(change('data.attributes.metadata.end_date', endDate))).then(() => {
              actions.mta.addEndorsements();
              actions.mta.handleMTASubmit();
            })
          });
        })
    }
  }

  private allowedMaxTripDuration = () => {
    return get(this.props, 'mta.policyInfo.meta.upsellMaxTripDuration', 30)
  }

  private handleOnchange = (selectedValue: string) => {
    const { formValues, actions } = this.props;
    if (get(formValues, 'metadata.region') !== selectedValue) {
      actions.mta.recalculateScreening(selectedValue, 'annual');
    }
    this.setState({ allowContinue: this.state.originalSelected !== selectedValue })
  }

  private renderPermissions = () => {
    const { permissions, actions, change, dispatch, formValues } = this.props;
    const product = actions.branding.getProduct();
    const renderDefinition = renderProductDefinition(product);
    const renewalStatus = get(formValues, 'metadata.renewal_status');

    return (
      <div>
        <MTACardConsent
          permissions={permissions}
        />
        <YourRenewal
          formPath={'data.attributes.metadata.renewal_status'}
          renderDefinition={renderDefinition}
          className={'no-padding'}
          allowAutoRenewal={permissions}
          defaultSelected={renewalTypeSelectionEnum.AUTO}
          change={change}
          renewalStatus={renewalStatus}
          dispatch={dispatch}/>
      </div>
    )
  }

  private handleGoBack = () => {
    const { actions } = this.props;
    actions.mta.setCompleteMTA();
    actions.push(`/account/summary`)
  }

  render() {
    const {
      mta,
      handleSubmit,
      submitting,
      submitFailed,
      valid,
      actions,
      dispatch,
      change,
      formValues
    } = this.props;
    const { allowContinue, loading, premiumMismatch } = this.state;
    const product = actions.branding.getProduct();
    const isLoading = mta.isLoading;
    const isUpsellRuleAllowed = get(mta, 'rules.canUpsell', false);
    const amtScheme = this.getAmtScheme();
    const allowedRegionsForUpsell = get(amtScheme, 'information.allowed_regions_upsell', [])
    const canShowMaxTripDuration = this.allowedMaxTripDuration() === 60;
    const upsellOptions = mta.upsellOptions || null;
    const hideUkRegion = get(mta, 'policyInfo.meta.hideUkRegion', false)
    const selectedRegion = get(formValues, 'metadata.region', '')
    const selectedDuration = parseInt(get(formValues, 'metadata.max_trip_duration', ''), 10);

    const annualTripDuration = getAnnualTripDurationOptions(product)

    const popoverClickRootClose = (
      <Popover id="popover-trigger-click-root-close" title="Regions">
        {!hideUkRegion && <Commonmark source={product.metadata.definitions.region_uk}/>}
        <Commonmark source={product.metadata.definitions.region_europe}/>
        <Commonmark source={product.metadata.definitions.region_worldwide_excluding}/>
        <Commonmark source={product.metadata.definitions.region_worldwide}
        />
      </Popover>
    );

    const popoverClickRootCloseTripExtension = (
      <Popover id="popover-trigger-click-root-close-trip-extension" title="TripExtension">
        <Commonmark
          source={'Annual Multi-Trip policies cover multiple trips of up to 31 days per trip as standard. You can increase the maximum trip duration for the policy term, either up to 45 days or up to 60 days per trip.'}/>
      </Popover>
    );

    const productRegions = RemoveRegion(product.metadata.regions, hideUkRegion);

    let regionsList = map(productRegions, (name, key) => {
      if (!isEmpty(allowedRegionsForUpsell)) {
        if (allowedRegionsForUpsell.includes(key)) {
          return {
            label: name,
            value: key,
          };
        }
      } else {
        return {
          label: name,
          value: key,
        };
      }
    });

    regionsList = compact(regionsList)

    if (loading) {
      return (
        <LoadingSpinner text={'Getting your policy details...'}/>
      )
    }

    {/*  This is a failsafe addon if the premium is not zero at this point for some reason */
    }
    if (premiumMismatch && !loading) {
      return (
        <MTAPremiumMismatch/>
      )
    }

    const submitButton = (
      <Button
        bsStyle="primary"
        type="submit"
        className="medium-width pull-right secondary-button"
        disabled={submitting || (submitFailed && !valid || !valid || isLoading) || !allowContinue}>
        {isLoading && (
          <FaSpinner className="fa-spin"/>
        )}
        CONTINUE
      </Button>
    );

    const goBackButton = (
      <Button
        bsStyle={'primary'}
        onClick={this.handleGoBack}
        className={'medium-width secondary-button'}>
        GO BACK
      </Button>
    )

    const subtext = (
      <>
        <div>
          Cover for multiple short duration trips.
        </div>
        <div>
          Please make sure you're selecting the correct region of travel to be sure you're covered.
        </div>
      </>
    )

    if (!premiumMismatch && !loading && isUpsellRuleAllowed) {
      return (
        <>
          <Form horizontal={true} onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off">
            <div className="admiral-card" style={{ marginTop: '20px' }}>
              <MTACardHeader
                text={'Upgrade to Annual Multi Trip Cover'}
                subtext={subtext}
                icon={'world1'}
                border={true}
              />
              <div className="body">
                <Grid fluid={true}>
                  <div>
                    <p style={{ marginTop: '20px' }}>
                      {'Where are you travelling to?'}
                      <OverlayTrigger
                        trigger="click"
                        rootClose={true}
                        placement="bottom"
                        overlay={popoverClickRootClose}
                      ><FaInfoCircle className="info-btn dark_blue"/>
                      </OverlayTrigger>
                    </p>

                    <MTARegionSelector
                      regionList={regionsList}
                      selectedRegion={selectedRegion}
                      handleChange={this.handleOnchange}
                    />

                  </div>
                  {canShowMaxTripDuration && (
                    <div>
                      <p>
                        {'What is your maximum trip length?'}
                        <OverlayTrigger
                          trigger="click"
                          rootClose={true}
                          placement="bottom"
                          overlay={popoverClickRootCloseTripExtension}
                        ><FaInfoCircle className="info-btn dark_blue"/>
                        </OverlayTrigger>
                      </p>

                      <MTATripDurationSelector
                        annualTripDuration={annualTripDuration}
                        selectedDuration={selectedDuration}
                      />
                    </div>
                  )}

                  <MTAVoucherCode campaign={upsellOptions?.campaign} dispatch={dispatch} change={change}/>
                  <div style={{ margin: '30px' }}>
                    {this.renderPermissions()}
                  </div>
                </Grid>
              </div>
            </div>
            <div style={{ marginTop: '15px' }}/>
            <MTAButtons button1={goBackButton} button2={submitButton}/>
          </Form>
        </>
      )
    }
  }
}

let selector;

export default flow([
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);
    return component;
  },
  connect(
    (state: IStore) => {
      const values = selector(
        state,
        'data.attributes',
      );
      const mtaPolicy = cloneDeep(state.mta.selectedPolicy);
      const latestPremium = last(mtaPolicy.premiums);
      const permissions = selector(state, 'permissions');
      mtaPolicy.effective_date = new Date();
      mtaPolicy.metadata.portal_mta = true;
      mtaPolicy.mta = true;
      mtaPolicy.scheme_id = latestPremium ? latestPremium.scheme.id : null;
      return {
        mtaPolicy,
        mta: state.mta,
        selectedPolicy: state.mta.selectedPolicy,
        i18n: state.branding.i18n,
        formValues: values,
        permissions,
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(MTAChangeTripTypeForm);
